import React from 'react';
import styles from './login.module.css';

interface LoginProps {
  loginPhase: string;
  qrcode: string | null;
} // Preview component
const Login: React.FC<LoginProps> = ({ loginPhase, qrcode }) => {
  return (
    <div className={styles['loading-overplay']}>
      <div className={styles['loading-content']}>
        <p>
          {loginPhase === 'init'
            ? '获取二维码中，请稍后'
            : loginPhase === 'qrcode'
            ? '请扫描二维码登录'
            : ''}
        </p>
        {qrcode && (
          <div
            className={styles['qrcode']}
            style={{
              backgroundImage: `url("data:image/png;base64,${qrcode}")`,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Login;
